import { Comparable198qfk8pnblz0 as Comparable } from '../Comparable.mjs';
import { CharSequence1ceii1xorfwh7 as CharSequence } from '../CharSequence.mjs';
//region block: imports
var isView = ArrayBuffer.isView;
//endregion
//region block: pre-declaration
//endregion
function isArrayish(o) {
  return isJsArray(o) || isView(o);
}
function isJsArray(obj) {
  // Inline function 'kotlin.js.unsafeCast' call
  return Array.isArray(obj);
}
function isCallableReference(value) {
  return typeof value === 'function' && value.$flags != null && value.$arity != null;
}
function isInterface(obj, iface) {
  return obj[iface.Symbol] === true;
}
function isArray(obj) {
  var tmp;
  if (isJsArray(obj)) {
    // Inline function 'kotlin.js.asDynamic' call
    tmp = !obj.$type$;
  } else {
    tmp = false;
  }
  return tmp;
}
function isSuspendFunction(obj, arity) {
  var objTypeOf = typeof obj;
  if (objTypeOf === 'function') {
    // Inline function 'kotlin.js.unsafeCast' call
    return obj.$arity === arity;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp1_safe_receiver = obj == null ? null : obj.constructor;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.$metadata$;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.suspendArity;
  var tmp;
  if (tmp3_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp3_elvis_lhs;
  }
  var suspendArity = tmp;
  var result = false;
  var inductionVariable = 0;
  var last = suspendArity.length;
  $l$loop: while (inductionVariable < last) {
    var item = suspendArity[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (arity === item) {
      result = true;
      break $l$loop;
    }
  }
  return result;
}
function isNumber(a) {
  var tmp;
  if (typeof a === 'number') {
    tmp = true;
  } else {
    tmp = !(a == null) ? typeof a === 'bigint' : false;
  }
  return tmp;
}
function isComparable(value) {
  var type = typeof value;
  return type === 'string' || type === 'boolean' || isNumber(value) || isInterface(value, Comparable());
}
function isCharSequence(value) {
  return typeof value === 'string' || isInterface(value, CharSequence());
}
function isBooleanArray(a) {
  return isJsArray(a) && a.$type$ === 'BooleanArray';
}
function isByteArray(a) {
  // Inline function 'kotlin.js.jsInstanceOf' call
  return a instanceof Int8Array;
}
function isShortArray(a) {
  // Inline function 'kotlin.js.jsInstanceOf' call
  return a instanceof Int16Array;
}
function isCharArray(a) {
  var tmp;
  // Inline function 'kotlin.js.jsInstanceOf' call
  if (a instanceof Uint16Array) {
    tmp = a.$type$ === 'CharArray';
  } else {
    tmp = false;
  }
  return tmp;
}
function isIntArray(a) {
  // Inline function 'kotlin.js.jsInstanceOf' call
  return a instanceof Int32Array;
}
function isFloatArray(a) {
  // Inline function 'kotlin.js.jsInstanceOf' call
  return a instanceof Float32Array;
}
function isDoubleArray(a) {
  // Inline function 'kotlin.js.jsInstanceOf' call
  return a instanceof Float64Array;
}
function jsIsType(obj, jsClass) {
  if (jsClass === Object) {
    return obj != null;
  }
  var objType = typeof obj;
  var jsClassType = typeof jsClass;
  if (obj == null || jsClass == null || (!(objType === 'object') && !(objType === 'function'))) {
    return false;
  }
  var constructor = jsClassType === 'object' ? jsGetPrototypeOf(jsClass) : jsClass;
  var klassMetadata = constructor.$metadata$;
  if ((klassMetadata == null ? null : klassMetadata.kind) === 'interface') {
    return isInterface(obj, constructor);
  }
  // Inline function 'kotlin.js.jsInstanceOf' call
  return obj instanceof constructor;
}
function jsGetPrototypeOf(jsClass) {
  return Object.getPrototypeOf(jsClass);
}
//region block: exports
export {
  isArrayish as isArrayish54psvuvyhrq3,
  isArray as isArray1hxjqtqy632bc,
  isBooleanArray as isBooleanArray35llghle4c6w1,
  isByteArray as isByteArray4nnzfn1x4o3w,
  isCallableReference as isCallableReference2kcn8l9rhew3g,
  isCharArray as isCharArray21auq5hbrg68m,
  isCharSequence as isCharSequence1ju9jr1w86plq,
  isComparable as isComparableviyv6ctzm76u,
  isDoubleArray as isDoubleArray1wyh4nyf7pjxn,
  isFloatArray as isFloatArrayjjscnqphw92j,
  isIntArray as isIntArrayeijsubfngq38,
  isInterface as isInterface3d6p8outrmvmk,
  isJsArray as isJsArray2xcmz54vi29am,
  isNumber as isNumberiramasdbon0i,
  isShortArray as isShortArraywz30zxwtqi8h,
  isSuspendFunction as isSuspendFunction153vlp5l2npj9,
  jsIsType as jsIsType3jt51kzl8sm7y,
};
//endregion

//# sourceMappingURL=typeCheckUtils.mjs.map
